import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'

import { StyledExpandableContainer } from 'components/molecules/expandedCard/index.styled'
import { OvulationInfo } from 'components/templates/ovulationCalculator/ovulationInfo'

export const parsedContentStyle = `p, li {
  margin-top: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #404040;
}
h3 {
  margin-top: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
}
ul {
  margin-top: 8px;
  padding-left: 16px;
  list-style-type: disc;
  li {
    margin-top: 8px;
  }
}
a {
  color: #1a80e3;
  &:not(:hover) {
    text-decoration: none;
  }
}`

export const StyledBabyPoopContainer = styled.div`
  margin: auto;
  padding-left: 16px;
  padding-right: 16px;
  max-width: calc(744px + 16px * 2);
  &[data-is-vietnam='true'] {
  }
`

export const StyledBabyPoopListItem = styled.div<{
  backgroundColor: string
  borderColor: string
}>`
  pointer-events: none;
  * {
    pointer-events: none;
  }
  border-radius: 4px;
  padding: 16px;
  cursor: pointer;
  transition: background-color 300ms;
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: ${theme.colors.neutral200};
  }

  img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
    border-radius: 4px;
    filter: blur(3px);
  }

  .item-see-more {
    color: ${theme.colors.primaryBase};
    font-size: 12px;
    margin-top: auto;
  }
`

export const StyledBabyPoopSignatureColorBar = styled.div<{
  signatureColor: string
  width: number | string
}>`
  width: ${(props) => props.width}px;
  height: 8px;
  background-color: ${(props) => props.signatureColor};
  border-radius: 4px;
  flex-shrink: 0;
`

export const StyledBabyPoopHeader = styled.div<{
  backgroundImage?: string
}>`
  background-image: url(${(props) => props.backgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: ${(props) =>
    props.backgroundImage ? 'transparent' : theme.colors.primary50};
  min-height: 400px;
  padding: 16px 0;

  .find-out-button {
    & * {
      pointer-events: none;
    }
  }
  &[data-is-vietnam='true'] {
    background-position: top center;
    min-height: 440px;
    background-size: cover;
  }
  ${MediaQueries.mbDown} {
    &[data-is-vietnam='true'] {
      min-height: 400px;
      background-size: cover;
      background-position: unset;
    }
  }
`

export const StyledBabyPoopHeaderContent = styled.div`
  display: flex;
  gap: 32px;
  padding: 24px 0;
  justify-content: space-between;
  .description {
    margin-top: 16px;
    white-space: pre-wrap;
  }
  .reviewer {
    margin-top: 16px;
    margin-bottom: 32px;
  }
  ${MediaQueries.mbDown} {
    flex-direction: column-reverse;
  }
  &[data-is-vietnam='true'] {
    padding: 0;
    padding-top: 80px;
    .description {
      margin-top: 6px;
    }
    .reviewer {
      margin-bottom: 0;
    }

    ${MediaQueries.mbDown} {
      flex-direction: column;
    }
  }
`

export const StyledBabyPoopHeaderContentText = styled.div<{
  isSponsored: boolean
}>`
  max-width: 647px;

  /* ${MediaQueries.mbUp} {
    padding-left: ${(props) => (props.isSponsored ? '100px' : 'unset')};
  } */
`

export const StyledBabyPoopHeaderContentImage = styled.img`
  max-width: 320px;

  ${MediaQueries.tdDown} {
    align-self: center;
  }

  &[data-is-vietnam='true'] {
    margin-top: -80px;
    align-self: end;
    pointer-events: none;
  }
`

export const StyledBabyPoopHeaderReview = styled.div`
  display: flex;
  gap: 4px;

  svg {
    margin-top: 3px;
    flex-shrink: 0;
  }

  a {
    color: ${theme.colors.gray600};
    font-weight: bold;

    &:not(:hover) {
      text-decoration: none;
    }
  }
`

export const StyledBabyPoopIntroduceParsedContent = styled.div`
  h2 {
    margin-top: 16px;
    font-weight: 700;
    font-size: 22px;
    line-height: 32px;
    color: ${theme.colors.gray800};
  }

  ${parsedContentStyle}
`

export const StyledBabyPoopInfo = styled(OvulationInfo)<{
  withDisclaimer: boolean
}>`
  &.faqs-block {
    ${(props) =>
      props.withDisclaimer
        ? `border-top: 8px solid ${theme.colors.neutral50};`
        : `margin-top: 24px;`}
  }

  p {
    transition: all 300ms;
  }

  ${StyledExpandableContainer} {
    ${parsedContentStyle}
  }
`

export const StyledBabyPoopInnerContent = styled.div`
  ${parsedContentStyle}
`
